import script from "./WizardCurtainCheckStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardCurtainCheckStep.vue?vue&type=script&setup=true&lang=js"

import "./WizardCurtainCheckStep.vue?vue&type=style&index=0&id=e17b54f4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e17b54f4"]])

export default __exports__